import { createAction, props } from '@ngrx/store';
import { PortfolioMandateType } from '@qvs/core';
import { createLoadingStatusActionGroup } from '~/shared/helpers/loading-status-helper';

const prefix = '[MandateType]';

export const {
  load: loadMandateTypes,
  success: loadMandateTypesSuccess,
  failure: loadMandateTypesFailure
} = createLoadingStatusActionGroup(prefix, 'mandate types');

export const upsertMandateTypes = createAction(`${prefix} upsert mandate types`, props<{ entities: PortfolioMandateType[] }>());
